import { ApiClient as ApiClientClass } from './apiClient';
import apiConfig from '../configuration/api';

const apiClientInstance = new ApiClientClass(apiConfig.baseUrl);

export const ApiClient = apiClientInstance;
